<template>
  <BaseModal @close="$emit('close')">
    <template v-slot:title>Confirmar Entrega</template>
    <div class="confirmation-content">
      <p>
        Deseja confirmar a entrega do pedido <strong>#{{ pedido.id }}</strong>,
        contendo {{ pedido.quantidade }}x {{ pedido.produto ? pedido.produto.nome : 'Produto' }}
        para <strong>{{ pedido.nome }}</strong>?
      </p>
    </div>
    <template v-slot:actions>
      <button @click="$emit('close')" class="modal-btn-no" :disabled="loading">Não</button>
      <button @click="confirmarEntrega" class="modal-btn-yes" :disabled="loading">
        {{ loading ? 'Confirmando...' : 'Sim' }}
      </button>
    </template>
  </BaseModal>
</template>

<script>
import api from '@/services/api';
import { AlertBus } from '@/plugins/AlertBus.js';
import BaseModal from '@/components/BaseModal.vue';

export default {
  name: "ModalConfirmarEntrega",
  components: { BaseModal },
  props: {
    pedido: { type: Object, required: true }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async confirmarEntrega() {
      this.loading = true;
      try {
        await api.post(`/api/admin/pedidos/${this.pedido.id}/marcar-entregue`, {});
        AlertBus.$emit('show-alert', { message: `Pedido #${this.pedido.id} entregue!`, type: 'success' });
        this.$emit('refresh'); // Avisa o pai para recarregar a lista
        this.$emit('close');   // Fecha o modal
      } catch (err) {
        const errorText = err.response?.data?.error || err.message;
        AlertBus.$emit('show-alert', { message: errorText, type: 'erro' });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.confirmation-content {
  font-size: 1.1rem;
  line-height: 1.5;
  text-align: center;
  padding: 10px 0;
}

.modal-btn-no, .modal-btn-yes {
  padding: 10px 20px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  font-weight: bold;
  font-size: 1rem;
  transition: all 0.2s;
}

.modal-btn-no {
  background-color: var(--bg-icon-button);
  color: var(--text-main);
  border: 1px solid var(--border-light);
}
.modal-btn-no:hover:not(:disabled) {
  background-color: var(--bg-icon-button-hover);
}

.modal-btn-yes {
  background-color: #4caf50;
  color: white;
}
.modal-btn-yes:hover:not(:disabled) {
  opacity: 0.9;
}
.modal-btn-yes:disabled, .modal-btn-no:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>